import FontBody2 from "../../fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../fonts/font-props";

interface IInputErrorMessagesProps {
    messages?: string[];
}

const InputErrorMessages = ({ messages }: IInputErrorMessagesProps) => {
    if (!messages || messages.length === 0) {
        return null;
    }

    return (
        <div>
            <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER}>{messages.join(', ')}</FontBody2>
        </div>
    )
}

export default InputErrorMessages;